<script lang="ts">
	//Helpers
	import { real_id_z } from '../../../../helpers/interface_helpers';
	import { capFirstChar } from '../../../../helpers/utilities';

	//Services
	import { format } from '../../../../services/i18n';
	import { postReq } from '../../../../services/http';

	//Configs
	import { devices_config_wave } from 'src/devices_config_wave';

	//Design system components
	import { Alert, Button, toast } from '@Shelly/shelly-design-system';

	//Components
	import FactoryResetModal from 'src/components/FactoryResetModal.svelte';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { deleteDevice } from 'src/helpers/add_delete_helpers';
	import { resetDrawerClose } from 'src/helpers/drawer_helpers';

	export let device;

	const id = real_id_z(device.id);

	let showModal = false;

	const type = devices_config_wave[device.type].friendly_name;

	let loading = false;
	let factoryLoading = false;

	const factoryReset = async () => {
		factoryLoading = true;
		loading = true;

		const params = {
			id: real_id_z(device.id),
			dsk: device.dsk,
			a: 'nl_del_n', //delete node
		};
		const res: SettingRequest = await postReq(`/fast/device/zw`, {
			...params,
		});

		if (res.isok) {
			resetDrawerClose();
			toast.open({
				type: 'success',
				title: $format('factory_reset_scc_toast', {
					values: { device_name: device.name },
				}),
				duration: 10000,
			});
			await deleteDevice(id);
		} else if (res?.errors?.code == 500) {
			await deleteDevice(id);
			// toast.open({type:'danger', title:$format('factory_reset_err_toast')});
		} else {
			toast.open({ type: 'danger', title: $format('factory_reset_err_toast') });
		}
		// await onSettingsResponse(res, device);
		loading = false;
		factoryLoading = false;
	};
	const props = {
		title: `${$format('reset_device_to_factory_stngs', {
			default: 'Reset Device to Factory Settings',
		})}?`,
		name: device?.name,
		text: $format('resetting_device_msg', {
			values: { device_name: device.name },
			default:
				'Resetting the device ‘{device_name}’ to its factory settings will erase all data and settings, including its network configuration. To reconnect, use its Access Point network.',
		}),
		alert: {
			heading: $format('resseting_device_alert_msg', {
				default:
					'Resetting the device to factory settings will also delete the device from the app.',
			}),
			type: 'danger',
		},
		button_1: $format('button_reset_device', {
			default: 'Reset device',
		}),
		button_1_variant: 'danger',
		button_2: $format('button_cancel'),
		callback: factoryReset,
	};
	//TODO: add correct command and props waiting for API
</script>

<!-- <Alert class="mb-s" type="warning" heading={'Under construction'} /> -->
<Alert
	class="mb-s"
	type="warning"
	heading={$format('factory_reset_description', { values: { type } })}
/>

<Button loading={factoryLoading} size="m" width="full" on:click={() => (showModal = true)}
	>{capFirstChar($format('button_factory_reset'))}</Button
>
{#if showModal}
	<FactoryResetModal bind:showModal {props} />
{/if}
